// hooks/useSelectionLogic.js
import { inRange, isEmpty } from "lodash";
import { useState, useEffect, useCallback } from "react";
import BetSlipContext from "../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

const useSelectionLogic = ({
  user,
  profileData,
  detail,
  typeGame,
  marketId,
  totalMatched,
  scrollToItem,
  setLocalLimit,
  localLimit,
  marketName,
}) => {
  const { t } = useTranslation();
  const oneclickActive = useContextSelector(AuthContext, (ctx) => {
    return ctx.oneclickActive;
  });
  const oneClickBid = useContextSelector(AuthContext, (ctx) => {
    return ctx.oneClickBid;
  });
  const defaultStakeLimit = useContextSelector(AuthContext, (ctx) => {
    return ctx.defaultStakeLimit;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const handelPlaceBetFair = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBetFair;
  });
  const setLimit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLimit;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const setOneClickBetLoader = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setOneClickBetLoader;
  });
  const location = useLocation();
  let loc = location?.pathname?.split("/");
  const handelChange = useCallback(
    (odds, type, team, item, e, index) => {
      if (!isEmpty(user)) {
        if (odds?.rt > 0) {
          setShowBetDialog(true);
          if (loc[1] != "match-detail-sky" && !isMobile) {
            scrollToItem(e.currentTarget);
          }
          let object = {
            odds: odds?.rt,
            teamName: team,
            index: index,
            betType: type,
            playType: typeGame,
            newMarketId: marketId,
            object: {
              ...item,
              ...odds,
              teamName: team,
              eventId: detail?.eventId,
              eventName:detail?.eventName,
              marketId: marketId,
              newMarketId: marketId,
            },
          };

          // if (oneclickActive) {
          //   setOneClickBetLoader(team);
          //   handelPlaceBetFair(localLimit, {
          //     ...object,
          //     bidPrice: oneClickBid,
          //   });
          // }
          setLimit(localLimit);
          setBetSlipObject((prev) => ({ ...prev, ...object }));
        }
      } else {
        setToastObject({
          type: "warning",
          title: t("Warning"),
          message: t("PleaseLoginToPlaceBet"),
          status: true,
        });
      }
    },
    [
      user,
      oneclickActive,
      oneClickBid,
      setShowBetDialog,
      handelPlaceBetFair,
      setLimit,
      setBetSlipObject,
      setToastObject,
      setOneClickBetLoader,
      detail,
      marketId,
      typeGame,
    ]
  );

  const handelLimit = useCallback(
    (marketName) => {
      let result = profileData?.matchSetting?.find(
        (res) => res?.type == marketName
      );
      if (!isEmpty(result)) return result;

      let obj = profileData?.matchSetting?.find(
        (res) =>
          res?.type == "betFaire" &&
          (profileData?.arrayCheck == "details"
            ? true
            : res?.sportType == detail?.gameType)
      );

      if (obj) {
        if (marketName == "Match Odds" && !isEmpty(detail?.betLimitSetting)) {
          return {
            ...obj,
            minAmount: detail?.betLimitSetting?.minBet,
            maxAmount: detail?.betLimitSetting?.maxBet,
          };
        }
        return obj;
      }

      return { maxAmount: 500, maxProfit: 10000, minAmount: 1, oddsLimit: 20 };
    },
    [profileData, detail]
  );

  useEffect(() => {
    if (detail?.gameType == "horse") {
      setLocalLimit({ minAmount: 1, maxAmount: 200, oddsLimit: 100 });
    } else {
      if (["Winner", "Win"].includes(detail?.market)) {
        setLocalLimit({ maxAmount: 100000, minAmount: 100, oddsLimit: 20 });
      } else {
        let limit = handelLimit(marketName);

        let newLimit = defaultStakeLimit?.find(
          (res) =>
            res?.betfairId == detail?.eventType &&
            res?.market == marketName &&
            inRange(totalMatched, res?.min, res?.max)
        );

        if (newLimit) {
          setLocalLimit({ ...limit, maxAmount: newLimit?.stake });
        } else {
          setLocalLimit(limit);
        }
      }
    }
  }, [detail, defaultStakeLimit, totalMatched]);

  const isRtValid = useCallback((obj, limit) => {
    const { rt } = obj;
    if (rt === undefined || rt === null || rt === "" || rt === 0) return true;
    if (typeof rt === "number" && limit !== undefined) {
      return rt >= limit?.oddsLimit;
    }
    return false;
  }, []);

  const checkArrays = useCallback(
    (arr1, arr2, limit) => {
      const combined = [...(arr1 || []), ...(arr2 || [])];
      return combined.length > 0
        ? combined.every((obj) => isRtValid(obj, limit))
        : true;
    },
    [isRtValid]
  );

  // function checkArrays(backArray = [], layArray = [], limit) {
  //   if (!limit) return false;

  //   const limitOdds = limit.oddsLimit ?? 0;

  //   const backExceeded = backArray.some((x) => x?.rt > limitOdds);
  //   const layExceeded = layArray.some((x) => x?.rt > limitOdds);

  //   return backExceeded || layExceeded;
  // }
  return { handelChange, checkArrays };
};

export default useSelectionLogic;
